<template>
    <div class="ah-page loan-list-page">
        <div class="page-header-v2">
            <div class="ah-container">
                <div>
                    <el-button type="text" @click="onBack" class="back-btn" icon="el-icon-back">返回</el-button>
                </div>
                <h1 class="title">{{ detail.title }}</h1>
                <div style="margin-top: 20px">
                    <div class="">核准日期：{{ detail.approvalDate | dateFormater("YYYY-MM-dd") }}</div>
                    <div class="">合約總額度：<Money :v="detail.totalAmount" style="font-size: 15pt" /></div>
                </div>
                <el-button size="mini" type="primary" plain @click="onEdit">編輯</el-button>
            </div>
        </div>
        <div>
            <div class="ah-container">
                <el-row :gutter="20">
                    <el-col :sm="6">
                        <div class="ah-block" style="margin-bottom: 20px" v-if="detail.amortizationAmount > 0">
                            <div class="block-title small">
                                <div style="font-size: 12pt; font-weight: bold">平均攤還</div>
                            </div>
                            <div class="ah-data-list">
                                <div class="item">
                                    <span class="label">合約額度</span>
                                    <span class="value" style="font-size: 17pt"><Money :v="detail.amortizationAmount" /></span>
                                </div>
                                <div class="item">
                                    <span class="label">還款期限</span>
                                    <span class="value">{{ detail.amortizationEndDate | dateFormater("YYYY-MM-dd") }}</span>
                                </div>
                                <div class="item">
                                    <span class="label">固定繳款日</span>
                                    <span class="value">每月 {{ detail.amortizationFixedPaymentDate }} 日</span>
                                </div>
                                <div class="item">
                                    <span class="label">已動撥總額：</span>
                                    <span class="value"><Money :v="amortizationDrawingAmtTilToday" /></span>
                                </div>
                                <div class="item">
                                    <span class="label">已還款總額：</span>
                                    <span class="value"><Money :v="amortizationReturnAmtTilToday" /></span>
                                </div>
                                <div class="item" v-if="amortizationDrawingAmtInFuture > 0">
                                    <span class="label">預約動撥總額<ah-tip>已登錄，但日期還未到的動撥</ah-tip>：</span>
                                    <span class="value"><Money :v="amortizationDrawingAmtInFuture" /></span>
                                </div>
                                <div class="item" v-if="amortizationReturnAmtInFuture > 0">
                                    <span class="label">預約還款總額<ah-tip>已登錄，但日期還未到的還款</ah-tip>：</span>
                                    <span class="value"><Money :v="amortizationReturnAmtInFuture" /></span>
                                </div>
                                <div class="item" style="font-size: 10pt" v-if="amortizationDrawingAmt > 0">
                                    <div class="label" style="padding-top: 10px">總還款進度</div>
                                    <div class="value" style="padding-top: 10px">{{ statisticData.amortizationPercent }} %</div>
                                </div>
                            </div>
                            <el-progress
                                v-if="statisticData && amortizationDrawingAmt > 0"
                                :percentage="statisticData.amortizationPercent"
                                :show-text="false"
                                color="#92DE56"
                                :stroke-width="7"
                                style="width: 100%; margin-bottom: 20px"
                            ></el-progress>
                            <div class="ah-data-list">
                                <div class="item">
                                    <span class="label">可用額度：</span>
                                    <span class="value"><Money :v="amortizationAvailableAmt" /></span>
                                </div>
                            </div>
                            <div class="actions" style="margin-top: 10px">
                                <el-button :disabled="amortizationAvailableAmt <= 0" size="small" plain :type="amortizationAvailableAmt <= 0 ? '' : 'primary'" @click="onAddDrawRequest(2)">
                                    動撥
                                </el-button>
                            </div>
                        </div>
                        <div class="ah-block" style="margin-bottom: 20px" v-if="detail.repaymentAmount > 0">
                            <div class="block-title small">
                                <div>循環額度一次還本</div>
                            </div>
                            <div class="ah-data-list">
                                <div class="item">
                                    <span class="label">合約額度</span>
                                    <span class="value" style="font-size: 17pt"><Money :v="detail.repaymentAmount" /></span>
                                </div>
                                <div class="item">
                                    <span class="label">額度到期日</span>
                                    <span class="value">{{ detail.repaymentEndDate | dateFormater("YYYY-MM-dd") }}</span>
                                </div>
                            </div>
                            <div class="ah-data-list">
                                <div class="item">
                                    <span class="label">已動撥總額</span>
                                    <span class="value"><Money :v="revolvingTotalDrawingTilTodayAmt" /></span>
                                </div>
                                <div class="item">
                                    <span class="label">已還款總額</span>
                                    <span class="value"><Money :v="revolvingTotalReturnTilTodayAmt" /></span>
                                </div>
                                <div class="item" v-if="revolvingTotalDrawingInFutureAmt > 0">
                                    <span class="label">預約動撥總額<ah-tip>已登錄，但日期還未到的動撥</ah-tip></span>
                                    <span class="value"><Money :v="revolvingTotalDrawingInFutureAmt" /></span>
                                </div>
                                <div class="item" v-if="revolvingTotalReturnInFutureAmt > 0">
                                    <span class="label">預約還款總額<ah-tip>已登錄，但日期還未到的還款</ah-tip></span>
                                    <span class="value"><Money :v="revolvingTotalReturnInFutureAmt" /></span>
                                </div>
                            </div>
                            <div class="ah-data-list" style="margin-top: 10px">
                                <div class="item">
                                    <span class="label">可用額度</span>
                                    <span class="value"><Money :v="revolvingAvailableAmt" /> / <Money :v="detail.repaymentAmount" /></span>
                                </div>
                            </div>
                            <el-progress
                                v-if="statisticData"
                                :percentage="revolvingAvailablePercent"
                                :show-text="false"
                                color="#92DE56"
                                :stroke-width="7"
                                style="width: 100%; margin-bottom: 20px"
                            ></el-progress>
                            <div class="actions" style="margin-top: 10px">
                                <el-button :disabled="revolvingAvailableAmt <= 0" size="small" plain :type="revolvingAvailableAmt <= 0 ? '' : 'primary'" @click="onAddDrawRequest(1)"> 動撥 </el-button>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="18">
                        <div class="ah-block">
                            <div style="display: flex; flex-direction: column; gap: 60px">
                                <div v-if="detail.amortizationAmount > 0">
                                    <div class="block-title small">
                                        <div>平均攤還-動撥</div>
                                        <el-button size="small" @click="onExport(amortizationDatas, 'amortization')">匯出Excel</el-button>
                                    </div>
                                    <div class="panel-body">
                                        <TableView2 :datas="amortizationDatas" :loading="isLoading" :repaymentPeriods="detail.repaymentPeriods" @open="onOpenDialog" @row-click="onRowClick" />
                                    </div>
                                </div>
                                <div v-if="detail.repaymentAmount > 0">
                                    <div class="block-title small">
                                        <div>循環額度一次還本-動撥</div>
                                        <el-button size="small" @click="onExport(revolvingDatas, 'revolving')">匯出Excel</el-button>
                                    </div>
                                    <div class="panel-body">
                                        <TableView2 :datas="revolvingDatas" :loading="isLoading" :repaymentPeriods="detail.repaymentPeriods" @open="onOpenDialog" @row-click="onRowClick" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <DrawDetailDialog ref="drawDetailDialog" :visible="drawDetailDialog.visible" :sno="drawDetailDialog.sno" @open="onOpenDialog" @close="onDrawDetailDialogClose" />
        <DrawRequestDialog :visible="drawRequestDialog.visible" :contrast="detail" :sno="drawRequestDialog.sno" :repaymentWay="drawRequestDialog.repaymentWay" @close="onDrawRequestDialogClose" />
        <ReturnDialog :visible="returnDialog.visible" :contrast="detail" :drawdown="returnDialog.drawdown" :sno="returnDialog.sno" @close="onReturnDialogClose" />
    </div>
</template>

<script>
import _ from 'lodash';
import TableView2 from './LoanDetailTableView2.vue';
import DrawDetailDialog from './DrawDetailDialog.vue';
import DrawRequestDialog from './DrawRequestDialog.vue';
import ReturnDialog from './ReturnDialog.vue';
import DrawdownExcelMixins from './DrawdownExcelMixins';

export default {
    mixins: [DrawdownExcelMixins],
    components: {
        TableView2,
        DrawDetailDialog,
        DrawRequestDialog,
        ReturnDialog,
    },
    data() {
        return {
            datas: [],
            isLoading: false,
            detail: {
                title: null,
                totalAmount: null,
            },
            statisticData: {
                lastDrawdownDate: null,
                lastRepayDate: null,
                lastADrawdownDate: null,
                lastRDrawdownDate: null,
            },
            drawDetailDialog: { visible: false, sno: null },
            drawRequestDialog: { visible: false, sno: null, repaymentWay: null },
            returnDialog: { visible: false, drawdown: null, sno: null },
        };
    },
    computed: {
        loanSno() {
            return this.$route.params.sno;
        },
        repaymentProgress() {
            return 50;
        },
        // 平均攤還動撥列表
        amortizationDatas() {
            return _.filter(this.datas, { repaymentWay: 2 });
        },
        // 循環額度動撥列表
        revolvingDatas() {
            return _.filter(this.datas, { repaymentWay: 1 });
        },
        // 循環額度 已動撥總額（含未來）
        revolvingTotalDrawingAmt() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .map((o) => o.amount)
                .sum()
                .value();
        },
        // 循環額度 已還款總額（含未來）
        revolvingTotalReturnAmt() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .map((o) => _.sumBy(o.repaymentList, 'principalAmount'))
                .sum()
                .value();
        },
        // 循環額度 已動撥總額（含未來）
        revolvingTotalDrawingAmt() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .map((o) => o.amount)
                .sum()
                .value();
        },
        // 循環額度 預約還款總額（未來）
        revolvingTotalReturnInFutureAmt() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .map((o) => _.sumBy(
                    _.filter(o.repaymentList, (x) => x.repaymentDate > +new Date()),
                    'principalAmount',
                ))
                .sum()
                .value();
        },
        // 循環額度 預約動撥總額
        revolvingTotalDrawingInFutureAmt() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .filter((x) => x.drawdownDate > +new Date())
                .map((o) => o.amount)
                .sum()
                .value();
        },
        // 循環額度 可用餘額
        revolvingAvailableAmt() {
            return this.detail.repaymentAmount - this.revolvingTotalDrawingAmt + this.revolvingTotalReturnTilTodayAmt;
        },
        // 循環額度 可用餘額 %
        revolvingAvailablePercent() {
            if (this.revolvingAvailableAmt && this.detail.repaymentAmount) return Math.round((this.revolvingAvailableAmt / this.detail.repaymentAmount) * 100);
            return 0;
        },
        // 循環額度 已動撥總額（截至今日，不含未來）
        revolvingTotalDrawingTilTodayAmt() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .filter((x) => x.drawdownDate <= +new Date())
                .map((o) => o.amount)
                .sum()
                .value();
        },
        // 循環額度 已還款總額（截至今日，不含未來）
        revolvingTotalReturnTilTodayAmt() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .map((o) => _.sumBy(
                    _.filter(o.repaymentList, (x) => x.repaymentDate <= +new Date()),
                    'principalAmount',
                ))
                .sum()
                .value();
        },

        // 平均攤還 可用餘額
        amortizationAvailableAmt() {
            return this.detail.amortizationAmount - this.amortizationDrawingAmt;
        },
        // 平均攤還 已動撥總額（含未來）
        amortizationDrawingAmt() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 2])
                .map((o) => o.amount)
                .sum()
                .value();
        },
        // 平均攤還 已動撥總額（至今日）
        amortizationDrawingAmtTilToday() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 2])
                .filter((x) => x.drawdownDate <= +new Date())
                .map((o) => o.amount)
                .sum()
                .value();
        },
        // 平均攤還 預約動撥總額（未來日）
        amortizationDrawingAmtInFuture() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 2])
                .filter((x) => x.drawdownDate > +new Date())
                .map((o) => o.amount)
                .sum()
                .value();
        },
        // 平均攤還 已還款總額
        amortizationReturnAmtTilToday() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 2])
                .map((o) => _.sumBy(
                    _.filter(o.repaymentList, (x) => x.repaymentDate <= +new Date()),
                    'principalAmount',
                ))
                .sum()
                .value();
        },
        // 平均攤還 預還款總額（未來日）
        amortizationReturnAmtInFuture() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 2])
                .map((o) => _.sumBy(
                    _.filter(o.repaymentList, (x) => x.repaymentDate > +new Date()),
                    'principalAmount',
                ))
                .sum()
                .value();
        },
    },
    mounted() {
        this.updateData();
    },
    methods: {
        async updateData() {
            try {
                this.isLoading = true;
                await this.getLoanDetail();
                await this.getDrawDownList();
                this.getLatestDate();

                if (this.drawDetailDialog.visible) {
                    this.$refs.drawDetailDialog.fetchData();
                }
            } finally {
                this.isLoading = false;
            }
        },
        async getLoanDetail() {
            const resp = await this.$api({
                method: 'GET',
                url: 'LoanReceipt/GetLoanReceiptDrawdownStatistics',
                params: { LoanReceiptSno: this.loanSno },
            });

            this.detail = { ...resp.data.loanReceiptDetail };
            this.statisticData = {
                loanReceiptDrawdownAmount: resp.data.loanReceiptDrawdownAmount,
                loanReceiptRepaymentAmount: resp.data.loanReceiptRepaymentAmount,
                mainRepaymentPercent: Math.round(resp.data.mainRepaymentPercent * 100),
                amortizationPercent: Math.round(resp.data.amortizationPercent * 100),
                repaymentPercent: Math.round(resp.data.repaymentPercent * 100),
            };
        },
        async getDrawDownList() {
            const resp = await this.$api({
                method: 'GET',
                url: 'LoanReceipt/GetLoanReceiptDrawdownList',
                params: { LoanReceiptSno: this.loanSno, PageSize: 99, PageNum: 1 },
            });

            console.log('draw down list', resp);
            this.datas = resp.data.items;
        },
        getLatestDate() {
            let lastDrawDat = 0;
            let lastRepayDat = 0;
            let lastADrawdownDate = 0;
            let lastRDrawdownDate = 0;

            // 可用循環額度餘額日期
            _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .flatMap((o) => [o.drawdownDate, ..._.map(o.repaymentList, (x) => x.repaymentDate)])
                .forEach((date) => {
                    if (lastRDrawdownDate < date) lastRDrawdownDate = date;
                })
                .value();

            // 可用平均攤還餘額日期
            _.chain(this.datas)
                .filter(['repaymentWay', 2])
                .flatMap((o) => [o.drawdownDate, ..._.map(o.repaymentList, (x) => x.repaymentDate)])
                .forEach((date) => {
                    if (lastADrawdownDate < date) lastADrawdownDate = date;
                })
                .value();

            this.datas.forEach((draw) => {
                if (lastDrawDat < draw.drawdownDate) lastDrawDat = draw.drawdownDate;
                if (lastDrawDat < draw.drawdownDate) lastDrawDat = draw.drawdownDate;

                draw.repaymentList.forEach((repay) => {
                    if (lastRepayDat < repay.repaymentDate) lastRepayDat = repay.repaymentDate;
                });
            });
            this.statisticData.lastDrawdownDate = lastDrawDat;
            this.statisticData.lastRepayDate = lastRepayDat;
            this.statisticData.lastADrawdownDate = lastADrawdownDate;
            this.statisticData.lastRDrawdownDate = lastRDrawdownDate;
        },
        onBack() {
            this.$router.push({ name: 'loan-management' });
        },
        onAddDrawRequest(repaymentWay) {
            this.drawRequestDialog.visible = true;
            this.drawRequestDialog.repaymentWay = repaymentWay;
        },
        onOpenDialog({ type, data, drawdown }) {
            console.log('onOpen', drawdown);

            if (type === 'edit-draw-request') {
                this.drawRequestDialog.visible = true;
                this.drawRequestDialog.sno = drawdown.sno;
                this.drawRequestDialog.repaymentWay = drawdown.repaymentWay;
                return;
            }
            if (type === 'add-return') {
                this.returnDialog.visible = true;
                this.returnDialog.drawdown = data;
            } else if (type === 'edit-return') {
                console.log('drawdown', drawdown);
                this.returnDialog.visible = true;
                this.returnDialog.sno = data.sno;
                this.returnDialog.drawdown = drawdown;
            }
        },

        onEdit() {
            this.$router.push({ name: 'loan-management-edit' });
        },
        onRowClick(row) {
            this.drawDetailDialog.visible = true;
            this.drawDetailDialog.sno = row.sno;
        },
        onDrawRequestDialogClose(refresh) {
            this.drawRequestDialog.visible = false;
            this.drawRequestDialog.sno = null;
            this.drawRequestDialog.repaymentWay = null;
            if (refresh) this.updateData();
        },
        onReturnDialogClose(refresh) {
            this.returnDialog.visible = false;
            this.returnDialog.sno = null;
            this.returnDialog.drawdown = null;
            if (refresh) this.updateData();
        },
        onDrawDetailDialogClose(refresh) {
            this.drawDetailDialog.visible = false;
            this.drawDetailDialog.sno = null;
            if (refresh) this.updateData();
        },
    },
};
</script>

<style lang="scss" scoped>
.ah-data-list {
    display: table;
    width: 100%;
    font-size: 10.5pt;
    > .item {
        display: table-row;

        &:hover {
            background-color: #f6f6f6;
            cursor: default;
        }

        > * {
            display: table-cell;
            padding: 1px 0;

            &:last-child {
                text-align: right;
            }
        }
    }
}
.loan-list-page {
    .summary-data-block {
        .loan-detail-title {
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 11pt;
            &:first-child {
                display: flex;
                align-items: center;
            }
            .system-no {
                font-size: 9pt;
                color: #aaa;
                margin-left: 10px;
            }
        }
        .loan-detail-data {
            font-size: 10pt;
            display: flex;
            .category {
                margin-top: 10px;
            }
            .label {
                width: 140px;
            }
            .value {
                flex: 1;
            }
        }
        .ah-card {
            height: calc(100% - 25px);
        }

        .repayment-progress {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;
            .percentage-text {
                font-weight: bold;
                font-size: 13pt;
            }
        }
        .content {
            .label {
                font-size: 11pt;
            }
            &.short {
                width: 70%;
            }
        }
    }
}
</style>
